module.exports = __webpack_public_path__ + "static/blue-bg-6979187924e452fcbfc100e95252bde5.png";